import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Divider,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useLocation, useParams } from 'react-router';
import { authenticationService } from 'src/services';
import { get } from 'src/services/httpClient.service';
import dayjs from 'dayjs';

const Invoice = () => {
  const { orderId } = useParams();

  const API_URL = process.env.REACT_APP_BASE_API_URL;

  const invoiceRef = useRef<HTMLDivElement>(null);

  const [invoiceData, setInvoiceData] = useState<any>(null);
  const [companyInfo, setCompanyInfo] = useState<any>(null);
  const [logoFileUrl, setLogoFileUrl] = useState('');
  const companyName = localStorage.getItem('companyName') || 'N/A';

  const location = useLocation();

const {
  username,
  customerId,
  address,
  franchiseName,
  collectionDate,
  collectionPerson
} = (location.state as any) || {};

console.log('username',username)

  const valueOrNA = (value: any) =>
  value !== null &&
  value !== undefined &&
  value !== ''
    ? value
    : 'N/A';

  const getInvoiceDetails = async () => {
    const { vendorId, franchiseId } =
      authenticationService.getVendorFranchiseIds();

    try {
      const response = await get(`${API_URL}/api/orders/vendor/${vendorId}/franchise/${franchiseId}/getById`, { params: {orderId : orderId}});

      setInvoiceData(response?.data);
    } catch (error) {
      console.error('Invoice fetch error', error);
    }
  };

  const getCompanyInfo = async () => {
    const { vendorId } =
      authenticationService.getVendorFranchiseIds();

    try {
      const response = await get(
        `${API_URL}/api/application-config/vendor/${vendorId}/company-info`
      );
      console.log('response',response)
      setCompanyInfo(response);
    } catch (error) {
      console.error('Company info error', error);
    }
  };

  const getLogoDetails = async () => {
    const { vendorId } =
      authenticationService.getVendorFranchiseIds();

    try {
      const response = await get(
        `${API_URL}/api/application-config/vendor/${vendorId}/getLogoImage`,
        {
          responseType: 'blob'
        }
      );

      if (response) {
        setLogoFileUrl(URL.createObjectURL(response));
      }
    } catch (err) {
      console.log('Logo error', err);
    }
  };

  useEffect(() => {
    getLogoDetails();
    getCompanyInfo();
    getInvoiceDetails();

    return () => {
      if (logoFileUrl) {
        URL.revokeObjectURL(logoFileUrl);
      }
    };
  }, []);

  const handleDownloadPDF = async () => {
    if (!invoiceRef.current) return;

    const canvas = await html2canvas(invoiceRef.current, {
      scale: 2,
      useCORS: true
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');

    const pdfWidth = pdf.internal.pageSize.getWidth();

    const pdfHeight =
      (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(
      imgData,
      'PNG',
      0,
      0,
      pdfWidth,
      pdfHeight
    );

    pdf.save(
      `Invoice-${invoiceData?.voucherNo || orderId}.pdf`
    );
  };

  

  return (
    <Box p={3}>
      <Box
        display="flex"
        justifyContent="flex-end"
        gap={2}
        mb={2}
      >
        <Button
          variant="contained"
          onClick={handleDownloadPDF}
        >
          Download PDF
        </Button>

        <Button
          variant="outlined"
          onClick={() => window.print()}
        >
          Print
        </Button>
      </Box>

      <Paper
  ref={invoiceRef}
  elevation={3}
  sx={{
    maxWidth: 1000,
    margin: 'auto',
    p: 4
  }}
>
  {/* Header */}
  <Grid container spacing={2}>
    <Grid item xs={4}>
      <Box
        sx={{
          width: 220,
          height: 70,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {logoFileUrl ? (
          <img
            src={logoFileUrl}
            alt="Company Logo"
            style={{
              maxWidth: '220px',
              maxHeight: '70px',
              objectFit: 'contain'
            }}
          />
        ) : (
          <Typography>N/A</Typography>
        )}
      </Box>
    </Grid>

    <Grid item xs={8}>
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
      >
        {companyName}
      </Typography>

      <Typography align="center">
        {valueOrNA(companyInfo?.companyAddress)},
        {' '}
        {valueOrNA(companyInfo?.companyCity)},
        {' '}
        {valueOrNA(companyInfo?.companyState)}
        {' - '}
        {valueOrNA(companyInfo?.companyPincode)}
      </Typography>

      <Typography align="center">
        Email: {valueOrNA(companyInfo?.companyEmail)}
      </Typography>

      <Typography align="center">
        Phone: {valueOrNA(companyInfo?.companyPhone)}
      </Typography>

      <Typography align="center">
        GST No: {valueOrNA(companyInfo?.companyGst)}
      </Typography>
    </Grid>
  </Grid>

  <Divider sx={{ my: 2 }} />

  <Typography
    variant="h6"
    fontWeight="bold"
    gutterBottom
    textAlign="center"
  >
    PAYMENT RECEIPT
  </Typography>

  {/* Voucher Details */}
  <Grid container spacing={2}>
    <Grid item xs={6}>
      <Typography>
        <strong>Voucher No:</strong>{' '}
        {valueOrNA(invoiceData?.orderNo)}
      </Typography>
    </Grid>

    <Grid item xs={6} textAlign="right">
      <Typography>
        <strong>Date:</strong>{' '}
        {valueOrNA(
          invoiceData?.createdDate
            ? new Date(invoiceData.createdDate).toLocaleDateString('en-GB')
            : null
        )}
      </Typography>

      <Typography>
        <strong>Collected By:</strong>{' '}
        {valueOrNA(collectionPerson)}
      </Typography>
    </Grid>
  </Grid>

  <Divider sx={{ my: 2 }} />

  {/* Customer Details */}
  <Typography gutterBottom>
  <strong>Received With Thanks From:</strong>{' '}
  {valueOrNA(username)}
</Typography>

<Typography gutterBottom>
  <strong>Customer ID:</strong>{' '}
  {valueOrNA(customerId)}
</Typography>

<Typography gutterBottom>
  <strong>Address:</strong>{' '}
  {valueOrNA(address)}
</Typography>

  <Typography gutterBottom>
    <strong>Sum Of Amount:</strong>{' '}
    {valueOrNA(invoiceData?.payableAmount)}
  </Typography>

  <Typography gutterBottom>
    <strong>Payment Mode:</strong>{' '}
    {valueOrNA(invoiceData?.paymentMode)}
  </Typography>

  <Divider sx={{ my: 2 }} />

  {/* Subscription / Channel Details */}
<Typography
  variant="subtitle1"
  fontWeight="bold"
  gutterBottom
>
  Package Details
</Typography>

<TableContainer component={Paper} variant="outlined">
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell><strong>S.No</strong></TableCell>
        <TableCell><strong>Package Name</strong></TableCell>
        <TableCell><strong>Package Type</strong></TableCell>
        <TableCell align="right"><strong>NCF Charges</strong></TableCell>
        <TableCell align="right"><strong>Price (₹)</strong></TableCell>
        <TableCell align="right"><strong>Tax (₹)</strong></TableCell>
        {/* <TableCell align="right"><strong>Discount (₹)</strong></TableCell> */}
        <TableCell align="right"><strong>Total (₹)</strong></TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {invoiceData?.lineItems?.map(
        (item: any, index: number) => (
          <TableRow key={item.id}>
            <TableCell>{index + 1}</TableCell>

            <TableCell>
              {valueOrNA(item.itemName)}
            </TableCell>

            <TableCell>
              {valueOrNA(item.itemType)}
            </TableCell>

            <TableCell align="right">
              {Number(item.ncfCharges || 0).toFixed(2)}
            </TableCell>

            <TableCell align="right">
              {Number(item.price || 0).toFixed(2)}
            </TableCell>

            <TableCell align="right">
              {Number(item.taxAmount || 0).toFixed(2)}
            </TableCell>

            {/* <TableCell align="right">
              {Number(item.discountAmount || 0).toFixed(2)}
            </TableCell> */}

            <TableCell align="right">
              {Number(item.totalAmount || 0).toFixed(2)}
            </TableCell>
          </TableRow>
        )
      )}

      <TableRow>
        <TableCell colSpan={5} align="right">
          <strong>Grand Total</strong>
        </TableCell>
        <TableCell align="right">
          <strong>
            {Number(
              invoiceData?.payableAmount || 0
            ).toFixed(2)}
          </strong>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>

<Divider sx={{ my: 2 }} />


<Divider sx={{ my: 2 }} />

<Grid container spacing={2}>
  <Grid item xs={12}>
    <Typography>
      <strong>Total Amount:</strong> ₹
      {valueOrNA(invoiceData?.payableAmount)}
    </Typography>
  </Grid>
</Grid>

<Divider sx={{ my: 2 }} />

{/* Footer Details */}
<Grid container spacing={2}>
  <Grid item xs={6}>
    <Typography>
      <strong>Print Date & Time:</strong>{' '}
      {dayjs().format('DD/MM/YYYY HH:mm:ss')}
    </Typography>
  </Grid>

  <Grid item xs={6} textAlign="right">
    <Typography>
      <strong>Franchisee Name:</strong>{' '}
      {valueOrNA(franchiseName)}
    </Typography>
  </Grid>
</Grid>
  <Box
    mt={8}
    display="flex"
    justifyContent="space-between"
  >
    <Box textAlign="center">
      <Typography>
        __________________________
      </Typography>
      <Typography>
        Collected By Signature
      </Typography>
    </Box>

    <Box textAlign="center">
      <Typography>
        __________________________
      </Typography>
      <Typography>
        Customer Signature
      </Typography>
    </Box>
  </Box>
</Paper>
    </Box>
  );
};

export default Invoice;